import { fetcher } from "helpers/fetcher";

import { TGetUserRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUser = async (idUser?: string, language?: string) => {
  return await fetcher<TGetUserRes, any>(ENDPOINT.USER.GET_USER, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.GET_USER.version,
      [API_HEADER.LANGUAGE]: language,
      ...(idUser && { [API_HEADER.USER_ID]: idUser }),
    },
  });
};

export const queryGetUser = async (idUser?: string, language?: string) => {
  return (await getUser(idUser, language)).data;
};

queryGetUser._key = (idUser?: string, language?: string) => [
  ENDPOINT.USER.GET_USER.url,
  idUser,
  language,
];
